import styled from '@emotion/styled';

const NoMatchesMessage = styled('p')(({ theme }) => ({
  margin: 0,
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default NoMatchesMessage;
